import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { IStep } from "@/client/types";

interface Props {
    message: IStep;
}

const ChartDisplay: React.FC<Props> = ({ message }) => {
    const [chartImage, setChartImage] = useState<string | null>(null);

    useEffect(() => {
        const chart = message?.additional_kwargs?.chart;
        if (chart) {
            setChartImage(chart); // Directly set the base64 image string
        } else {
            setChartImage(null); // Reset if no image is found
        }
    }, [message]);

    if (!chartImage) return null; // Don't render if there's no chart

    return (
        <Box sx={{ maxWidth: "100%", overflow: "hidden", textAlign: "center" }}>
            <img
                src={chartImage}
                alt="Generated Chart"
                style={{ maxWidth: "100%", height: "auto", borderRadius: "8px" }}
            />
        </Box>
    );
};

export default ChartDisplay;
